<span class="font-medium-title-large">Coupon Codes generieren</span>
<span class="font-regular-body-large text-center">
  Füllen Sie die Felder aus und klicken Sie auf "Gutscheine generieren", um neue
  Gutscheine zu erstellen.
</span>
<form [formGroup]="form" class="flex-c gap-16 justify-center w-full">
  @if (couponCodes && couponCodes.length > 0) {
    <!-- add an readonly textarea with the coupon codes -->
    <div class="input-simple">
      <div class="input-label">Gutschein Codes</div>
      <textarea
        class="input-textarea"
        readonly
        [rows]="couponCodes.length"
        [value]="couponCodes.join('\n')"></textarea>
    </div>
  } @else {
    <div class="flex-c gap-16 justify-center padding-top-16">
      <div class="input-simple flex-1-0-0">
        <div class="input-label" for="amount">
          Anzahl an Gutscheinen{{
            fieldRequired(form.get('amount')) ? '*' : ''
          }}
        </div>
        <input
          id="amount"
          class="input-field"
          formControlName="amount"
          name="amount"
          type="number"
          autocomplete="off"
          placeholder="Anzahl" />
        <app-error-message [formField]="form.get('amount')"></app-error-message>
      </div>
      <div class="input-simple flex-1-0-0">
        <div class="input-label" for="title">
          Gutschein-Titel{{ fieldRequired(form.get('title')) ? '*' : '' }}
        </div>
        <input
          id="title"
          class="input-field"
          formControlName="title"
          name="title"
          type="text"
          autocomplete="off"
          placeholder="Gutschein-Titel" />
        <app-error-message [formField]="form.get('title')"></app-error-message>
      </div>
      <div class="input-simple flex-1-0-0">
        <div class="input-label" for="value">
          Gutschein-Wert{{ fieldRequired(form.get('value')) ? '*' : '' }}
        </div>
        <input
          id="value"
          class="input-field"
          formControlName="value"
          name="value"
          type="number"
          autocomplete="off"
          placeholder="Gutschein-Wert" />
        <app-error-message [formField]="form.get('value')"></app-error-message>
      </div>
      <div class="input-simple flex-1-0-0">
        <div class="input-label" for="expirationYear">
          Gültigkeitsdauer in Jahren{{
            fieldRequired(form.get('expirationYear')) ? '*' : ''
          }}
        </div>
        <input
          id="expirationYears"
          class="input-field"
          formControlName="expirationYears"
          name="expirationYears"
          type="number"
          autocomplete="off"
          placeholder="Gültigkeitsdauer in Jahren" />
        <app-error-message
          [formField]="form.get('expirationYears')"></app-error-message>
      </div>
    </div>
    <div class="input-simple flex-1-1-0">
      <label for="allowedSeminarIds" class="input-label">
        Gültig nur für bestimmte Seminare (optional)
      </label>
      <p-multiSelect
        id="allowedSeminarIds"
        appendTo="body"
        [options]="seminars"
        optionLabel="seminar.title"
        optionValue="seminar.id"
        placeholder="Seminare auswählen..."
        [loading]="isLoadingSeminars"
        formControlName="allowedSeminarIds"
        [showClear]="true"
        [filter]="true"
        display="chip"
        styleClass="w-full"
        panelStyleClass="filter-seminar-select-panel">
        <ng-template let-seminar pTemplate="item">
          <div class="flex align-items-center">
            <div>{{ seminar.seminar.title }}</div>
            @if (seminar.dates && seminar.dates.length > 0) {
              <span class="font-regular-body-medium text-secondary">
                {{ getSeminarDateString(seminar) }}
              </span>
            }
            @if (seminar.seminar.isDraft) {
              <span class="is-draft-tag"> Entwurf</span>
            }
          </div>
        </ng-template>
      </p-multiSelect>
      <small class="text-secondary"
        >Wenn leer, gilt der Code für alle Seminare</small
      >
    </div>

    <div class="input-simple flex-1-1-0">
      <label for="allowedConditionTypes" class="input-label">
        Gültig nur für bestimmte Preis-Kategorien (optional)
      </label>
      <p-multiSelect
        id="allowedConditionTypes"
        appendTo="body"
        [options]="conditionTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="Preis-Kategorien auswählen..."
        formControlName="allowedConditionTypes"
        [showClear]="true"
        display="chip"
        styleClass="w-full">
      </p-multiSelect>
      <small class="text-secondary"
        >Wenn leer, gilt der Code für alle Preis-Kategorien</small
      >
    </div>
  }
  <div class="flex-r gap-16 justify-center">
    @if (couponCodes && couponCodes.length > 0) {
      <button
        [disabled]="isLoading"
        type="button"
        class="inwi-icon-text-button-large-primary"
        (click)="onCopyCouponCodes()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-solid fa-copy"></i>
          </div>
          <div class="button-text">Gutscheine kopieren und schließen</div>
        </div>
      </button>
    } @else {
      <button
        [disabled]="isLoading"
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="closeDialog(false)">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-solid fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      <button
        [disabled]="isLoading"
        type="submit"
        class="inwi-icon-text-button-large-primary"
        (click)="onGenerateCouponCodes()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-solid fa-ticket"></i>
          </div>
          <div class="button-text">Gutscheine generieren</div>
        </div>
      </button>
    }
  </div>
</form>
